import type en from "./en"

const nb: typeof en = {
  "add-user.invite-users": "Inviter brukere",
  "add-users.add-more-users": "Legg til flere brukere",
  "add-users.send-invite": "Send invitasjon",
  "add-users.toasts.success": "Invitasjoner sendt!",
  "admin-required.message": "Du må være administrator for å se dette.",
  "auth.admin-or-user-required":
    "Du må være {user} eller en administrator for å se dette",
  "auth.goodbye": "Vi snakkes!",
  "auth.sign-out": "Logg ut",
  "billing-methods.ehf": "EHF",
  "billing-methods.labels.ehf": "Elektronisk handelsformat",
  "buy-new-subscription.title":
    "Du må kjøpe et nytt abonnement for å få tilgang til Arbeidsark.",
  "cancel-subscription-success.contact-form": "kontaktskjemaet",
  "cancel-subscription-success.description":
    "Vi ønsker stadig å forbedre oss. Er det noe som ikke fungerer slik du ønsker? Send oss gjerne en e-post på {contactLink} eller send oss en melding fra {contactForm}.",
  "cancel-subscription-success.title": "Synd du må forlate oss!",
  "cancel-subscription-success.toast-text": "Abonnementet ble avsluttet",
  "cancel-subscription.confirm-cancel":
    "Jeg er sikker på at jeg vil kansellere",
  "cancel-subscription.keep-subscription": "Behold abonnement",
  "cancel-subscription.subtitle": "Du har tilgang frem til {date}",
  "cancel-subscription.title":
    "Er du sikker på at du vil avslutte abonnementet?",
  "change-password.description":
    "Av sikkerhetsgrunner må du bytte passordet ditt før du logger inn på nytt.",
  "change-password.title": "Bytt passord",
  "change-payment-method-success.title": "Suksess!",
  "change-payment-method-success.toast": "Kortinformasjonen ble endret",
  "change-payment-method.submit-text": "Lagre",
  "change-payment-method.title": "Bytt betalingsinformasjon",
  "change-periodicity.save-success": "Faktureringsintervallet ble endret",
  "common.absence": "Fravær",
  "common.absences": "Fravær",
  "common.activate": "Aktiver",
  "common.active": "Aktiv",
  "common.activities": "Aktiviteter",
  "common.activity": "Aktivitet",
  "common.add": "Legg til",
  "common.add-file": "Legg ved fil",
  "common.add-files": "Legg ved filer",
  "common.address": "Adresse",
  "common.age": "Alder",
  "common.all": "Alle",
  "common.app": "App",
  "common.archive": "Arkivér",
  "common.author": "Forfatter",
  "common.availability":
    "{abbreviate, select, true {Tilgj.} other {Tilgjengelighet}}",
  "common.back": "Tilbake",
  "common.business": "Firma",
  "common.businessOverview": "Firmaoversikt",
  "common.cancel": "Avbryt",
  "common.cancel-changes": "Angre Endringer",
  "common.category": "Kategori",
  "common.change-organization": "Bytt firma",
  "common.city": "By",
  "common.clear": "Nullstill verdi",
  "common.close": "Lukk",
  "common.closed": "Lukket",
  "common.codes": "Koder",
  "common.contact-info": "Kontaktinfo",
  "common.contact-person": "Kontaktperson",
  "common.content": "Innhold",
  "common.country": "Land",
  "common.create": "Opprett ny",
  "common.create-entry": "Lag nytt innlegg",
  "common.create-folder": "Lag ny mappe",
  "common.create-worksheet": "Opprett arbeidsark",
  "common.creating": "Oppretter",
  "common.current-password": "Nåværende passord",
  "common.dashboard": "Kontrollpanel",
  "common.date": "Dato",
  "common.date-validation-not-in-future":
    "Dato må være gyldig og ikke i fremtiden",
  "common.day-end": "Dag slutt",
  "common.day-start": "Dag start",
  "common.days": "{days, plural, =0 {Ingen dager} one {# dag} other {# dager}}",
  "common.deactivate": "Deaktiver",
  "common.delete": "Slette",
  "common.delete-alt": "Slett",
  "common.delete-type": "Slett {type}",
  "common.description": "Beskrivelse",
  "common.detail": "Detalje",
  "common.distance": "Distanse",
  "common.document": "Dokument",
  "common.documentation": "Dokumentasjon",
  "common.documentationIssues": "Dokumentasjonsavvik",
  "common.documents": "Dokumenter",
  "common.download": "Last ned",
  "common.driver": "Sjåfør",
  "common.drivers": "Sjåfører",
  "common.drivers-handbook": "Sjåførhåndbok",
  "common.driversHandbook": "Sjåførhåndbok",
  "common.driving": "Kjøring",
  "common.driving-data": "Kjøredata",
  "common.dropdown": "Nedtrekksmeny",
  "common.dropdown-on-pages": "Bruker dropdown på side",
  "common.edit": "Endre",
  "common.edit-alt": "Redigér",
  "common.edit-type": "Redigér {type}",
  "common.ehf": "EHF",
  "common.electronic-invoicing": "Elektronisk handelsformat",
  "common.email": "E-post",
  "common.email-taken": "E-posten er opptatt",
  "common.employee": "Ansatt",
  "common.end": "Slutt",
  "common.english": "Engelsk",
  "common.entry": "Innlegg",
  "common.eurovignette": "Eurovignette",
  "common.eurovignettes": "Eurovignettes",
  "common.expired": "Utløpt",
  "common.favourite": "Favoritt",
  "common.favourites": "Favoritter",
  "common.files": "Filer",
  "common.filter": "Filter",
  "common.first-grade": "Første klasse",
  "common.first-name": "Fornavn",
  "common.folder": "Mappe",
  "common.forum": "Forum",
  "common.gender": "Kjønn",
  "common.general": "Generelt",
  "common.handbook": "Håndbok",
  "common.home": "Hjem",
  "common.hourlist": "Timeliste",
  "common.hours": "Timer",
  "common.hours-lowercase": "timer",
  "common.in-app": "I app",
  "common.inactive": "Inaktiv",
  "common.information": "Informasjon",
  "common.invoicing": "Fakturering",
  "common.issue": "Avvik",
  "common.issues": "Avvik",
  "common.km": "km",
  "common.language": "Språk",
  "common.last-name": "Etternavn",
  "common.liters-short": "l",
  "common.loading": "Laster",
  "common.loading...": "Laster inn...",
  "common.log-in": "Logg inn",
  "common.log-out": "Logg ut",
  "common.login": "Login",
  "common.mathematics": "Matematikk",
  "common.month": "Måned",
  "common.monthly": "Månedlig",
  "common.multiple": "Flere",
  "common.my-worksheets": "Mine arbeidsark",
  "common.name": "Navn",
  "common.new-password": "Nytt passord",
  "common.new-password-again": "Gjenta nytt passord",
  "common.new-password-sent": "Nytt passord er sendt på mail!",
  "common.new-worksheet": "Nytt arbeidsark",
  "common.try-new-generator": "Ny generator",
  "common.try-new-generator-beta": "Beta",
  "common.next": "Neste",
  "common.no": "Nei",
  "common.norwegian": "Norsk",
  "common.notification": "Varsling",
  "common.nth-grade": "{grade, plural, other {#.}} klasse",
  "common.office": "Kontor",
  "common.ok": "OK",
  "common.open": "Åpne",
  "common.opened": "Åpen",
  "common.operation": "Operasjon",
  "common.organization": "Bedrift",
  "common.organization-name": "Bedriftsnavn",
  "common.organization-number": "Organisasjonsnummer",
  "common.other": "Annet",
  "common.other-work": "Annet arbeid",
  "common.overtime": "Overtid",
  "common.paper": "Papir",
  "common.password": "Passord",
  "common.pause": "Pause",
  "common.pending": "Venter godkjenning",
  "common.perks": "Fordeler",
  "common.phone": "Telefon",
  "common.phone-number": "Telefonnummer",
  "common.phone-prefix": "Landskode",
  "common.post-code": "Postkode",
  "common.postal-code": "Postnummer",
  "common.price-per-month": "{price} kr/mnd",
  "common.print": "Skriv ut",
  "common.range": "Område",
  "common.reason": "Årsak",
  "common.reg-nr": "Reg.nr.",
  "common.register": "Registrer",
  "common.required": "Påkrevd",
  "common.responsible": "Ansvarlig",
  "common.rest": "Hvile",
  "common.restore": "Gjenopprett",
  "common.role": "Rolle",
  "common.save": "Lagre",
  "common.save-changes": "Lagre Endringer",
  "common.saving": "Lagrer",
  "common.school": "Skole",
  "common.school-grade": "Klassetrinn",
  "common.search": "Søk ...",
  "common.second-grade": "2. klasse",
  "common.select-placeholder": "Gjør et valg",
  "common.settings": "Innstillinger",
  "common.sex": "Kjønn",
  "common.share": "Del",
  "common.shortcuts": "Snarveier",
  "common.show-all": "Vis alle",
  "common.single-user": "Enkeltbruker",
  "common.sms": "SMS",
  "common.start": "Start",
  "common.status": "Status",
  "common.street": "Gate",
  "common.subject": "Emne",
  "common.submit": "Send inn",
  "common.subscription": "Abonnement",
  "common.subscriptions": "Abonnement",
  "common.sum": "Sum",
  "common.terminal": "Terminal",
  "common.the-email": "E-posten",
  "common.theme": "Tema",
  "common.thread": "Tråd",
  "common.time-entries": "Timeliste",
  "common.timesinceposted": "Tid siden lagt ut",
  "common.title": "Tittel",
  "common.unfavourite": "Fjern favoritt",
  "common.update": "Oppdater",
  "common.update-entry": "Endre innlegg",
  "common.update-folder": "Endre mappe",
  "common.updating": "Oppdaterer",
  "common.uploaded-attachments": "Opplastede tillegg",
  "common.user": "Bruker",
  "common.user-types": "Brukertyper",
  "common.userType": "Brukertype",
  "common.username": "Brukernavn",
  "common.users": "Brukere",
  "common.vehicle": "Kjøretøy",
  "common.week": "Uke",
  "common.weeks": "{weeks, plural, =0 {Ingen uker} one {# uke} other {# uker}}",
  "common.welcome": "Velkommen",
  "common.work": "Arbeid",
  "common.year": "År",
  "common.yearly": "Årlig",
  "common.yes": "Ja",
  "common.zip-code": "Postnummer",
  "components.language-select.option-label":
    "{lang, select, nb {Målform (bokmål)} nn {Målform (nynorsk)} en {Engelsk (GB)} other {Ukjent}}",
  "confirm-reset-password.back-to-login": "Tilbake til innlogging",
  "confirm-reset-password.title": "Skriv inn nytt passord",
  "copy.success": "Kopiert til utklippstavlen",
  "createUser.title": "Opprett ny bruker",
  "dashboard.add-user": "Legg til brukere",
  "dashboard.lastForumPosts": "Siste innlegg",
  "dashboard.register-hours": "Registrér timer",
  "dashboard.subscription-expiring-banner.title":
    "Prøveperioden går ut {date}. Trykk her for å legge til betalingsinformasjon for å fortsette å bruke Arbeidsark.",
  "dashboard.welcome-text-my-worksheets":
    "Her vil du få en oversikt over dine arbeidsark. Du har enda ikke opprettet noen.",
  "dashboard.welcome-text-one":
    "Nyttig informasjon vil vises her etter du har opprettet et arbeidsark.",
  "dashboard.welcome-text-two":
    "Opprett et nytt arbeidsark ved å trykke på knappen nedenfor.",
  "document.files-for-document": "Filer tilhørende {name}",
  "documentation.documentation-for-control": "Dokumentasjon for kontroll",
  "documentation.drive-and-rest-time": "Kjøre og hviletid",
  "documents.documents-to-user": "Dokumentene til {user}",
  "documents.expiration-date": "Utløpsdato",
  "documents.name-on-document": "Navn på dokument",
  "documents.notification-time": "Tid for varsling",
  "documents.number-id": "Nummer/ID",
  "documents.responsible-user": "Ansvarsperson",
  "documents.show-files": "Vis filer",
  "documents.upload-document": "Last opp dokument",
  "documents.view-file": "Vis fil",
  "error.address-required": "Adresse er påkrevd",
  "error.categories": "Kunne ikke hente kategorier",
  "error.city-required": "By er påkrevd",
  "error.contact-person-phone-required":
    "Telefonnummer til kontaktperson er påkrevd",
  "error.contact-person-required": "Navn på kontaktperson er påkrevd",
  "error.could-not-change-profile-information":
    "Kunne ikke endre profilinformasjon",
  "error.could-not-check-in": "Kunne ikke sjekke inn",
  "error.could-not-check-out": "Kunne ikke sjekke ut",
  "error.could-not-create-type": "Kunne ikke lage {type}",
  "error.could-not-edit-type": "Kunne ikke endre {type}",
  "error.could-not-find-data": "Kunne ikke finne tabelldata",
  "error.could-not-read-file": "Kunne ikke lese fil",
  "error.create-issue": "Kunne ikke lage avvik",
  "error.field-is-required": "{field} er påkrevd",
  "error.files.could-not-read": "Kunne ikke lese fil",
  "error.first-name-required": "Fornavn er påkrevd",
  "error.generic": "Det har skjedd en feil",
  "error.generic-server-error":
    "Noe gikk galt på tjeneren. Vennligst prøv igjen.",
  "error.internal-number-required": "Internummer er påkrevd",
  "error.invalid-file-type": "Ugyldig filtype",
  "error.invalid-value": "Ugyldig verdi",
  "error.last-name-required": "Etternavn er påkrevd",
  "error.name-exists": "Det finnes allerede et innlegg med dette navnet",
  "error.need-organization-name": "Firmanavn må være fylt ut",
  "error.no-empty-fields": "Alle felt er tomme",
  "error.no-first-name": "Mangler fornavn",
  "error.no-valid-fields": "Ingen gyldige felt",
  "error.phone-number-required": "Telefonnummer er påkrevd",
  "error.postal-code-required": "Postnummer er påkrevd",
  "error.type-already-exist": "{type} eksisterer allerede",
  "error.update-issue": "Kunne ikke oppdatere avvik",
  "error.users-already-exist": "Brukere som allerede eksisterer: ",
  "error.valid-email-required": "Gyldig emailadresse er påkrevd",
  "error.wrong-username-or-password": "Feil brukernavn eller passord",
  "errors.change-password-weak": "Passordet er for svakt",
  "errors.common.name-already-exists": "Navnet eksisterer allerede",
  "errors.defaults.does-not-exist": "Objektet eksisterer ikke",
  "errors.defaults.foreign-key-constraint":
    "Objektet refererer til noe som ikke eksisterer",
  "errors.defaults.invalid-value": "En av de oppgitte verdiene var ugyldig",
  "errors.defaults.not-permitted":
    "Brukeren din har ikke tilgang til å gjøre dette",
  "errors.defaults.unique-constraint": "Objektet må være unikt",
  "errors.from-code.bad-input": "Dataen du oppga var ugyldig",
  "errors.from-code.configuration-not-found":
    "En gyldig konfigurasjon ble ikke funnet. Prøv å endre på klassetrinnet eller operasjonen du har valgt.",
  "errors.from-code.crossword-computation-failed":
    "Opprettelse av et gyldig kryssord feilet. Det kan bety at å opprette et kryssord for ordlisten du har oppgitt er veldig vanskelig eller umulig. Prøv igjen eller juster på ordlisten.",
  "errors.from-code.crossword-computation-timed-out":
    "Opprettelse av et gyldig kryssord feilet. Det kan bety at å opprette et kryssord for ordlisten du har oppgitt er veldig vanskelig eller umulig. Prøv igjen eller juster på ordlisten.",
  "errors.from-code.crossword-word-too-large":
    "Du har oppgitt et ord som er for langt for ethvert kryssord vi kan generere.",
  "errors.from-code.division-calculation-timed-out":
    "Noe gikk galt ved generering av en tilfeldig deleoppgave. Dette er nok bare uflaks på din side. Prøv igjen eller kontakt oss ved å bruke tilbakemeldingsknappen.",
  "errors.from-code.division-cannot-fit-half-page-grid-size":
    "Å få plass til en deleoppgave på en halvside med de tallene du har oppgitt er umulig. Prøv å endre på tallene du har oppgitt eller bruk fullside-layout.",
  "errors.from-code.division-layout-undeterminable":
    "Vi klarte ikke å finne en layout for en av deleoppgavene vi genererte. Dette er nok vår feil. Unnskyld. Vennligst kontakt oss ved å bruke tilbakemeldingsknappen.",
  "errors.from-code.email-already-taken": "E-posten er allerede registrert",
  "errors.from-code.incorrect-password": "Feil passord",
  "errors.from-code.internal-error": "En ukjent feil oppstod",
  "errors.from-code.invalid-credentials": "Feil brukernavn eller passord",
  "errors.from-code.language-category-not-defined":
    "Temaet du valgt finnes ikke. Har du klart å velge det vekk?",
  "errors.from-code.language-not-supported": "Språket er ikke støttet.",
  "errors.from-code.mathematics-not-allowed-for-wordlist-deduction":
    "Matematikk er ikke et lovlig fag å oppgi når ordlister skal brukes. Prøv å endre konfigurasjonen din, eller kontakt oss ved å bruke tilbakemeldingsknappen.",
  "errors.from-code.no-allowed-modules":
    "Ingen lovlige oppgavetyper ble funnet. Du må nok endre litt på konfigurasjonen din.",
  "errors.from-code.not-found": "Objektet eksisterer ikke",
  "errors.from-code.organization-name-already-taken":
    "Organisasjonsnavnet er allerede tatt",
  "errors.from-code.readingtext-only-full-layout":
    "Lesetekster kan bare bli opprettet med fullside layout",
  "errors.from-code.readingtexts-no-content-available":
    "En intern feil oppstart da vi prøvde å hente innholdet til leseteksten du fikk tildelt. Vennligst kontakt oss ved å bruke tilbakemeldingsknappen.",
  "errors.from-code.readingtexts-no-data-available":
    "Ingen lesetekster var tilgjengelig for de valgte klassetrinnene, språket og temaet.",
  "errors.from-code.remote-stripe-error":
    "Noe gikk galt hos Stripe. Ta kontakt med oss om problemet vedvarer.",
  "errors.from-code.stripe-customer-not-found":
    "Brukeren din er feilkonfigurert for Stripe. Ta kontakt med oss.",
  "errors.from-code.unauthenticated": "Du er ikke logget inn",
  "errors.from-code.unauthorized": "Du har ikke tilgang til å gjøre dette",
  "errors.from-code.unknown": "En ukjent feil oppst",
  "errors.from-code.wordlist-too-small":
    "Ordlisten er for liten til oppgaven du har valgt.",
  "errors.from-code.wordsearch-computation-failed":
    "Opprettelse av et gyldig ordsøk feilet. Det kan bety at å opprette et ordsøk for ordlisten du har oppgitt er veldig vanskelig eller umulig. Prøv igjen eller juster på ordlisten.",
  "errors.from-code.wordsearch-computation-timed-out":
    "Opprettelse av et gyldig ordsøk feilet. Det kan bety at å opprette et ordsøk for ordlisten du har oppgitt er veldig vanskelig eller umulig. Prøv igjen eller juster på ordlisten.",
  "errors.from-code.wordsearch-word-too-large":
    "Du har oppgitt et ord som er for langt for ethvert ordsøk vi kan generere.",
  "errors.generic-error": "Noe har gått galt",
  "errors.generic-not-empty-field": "Kan ikke være tom",
  "errors.invalid": "Ugyldig",
  "errors.invalid-email-address": "E-post er ugyldig",
  "errors.invalid-email-fields": "Ugyldige datafelt: ",
  "errors.invalid-phone-number": "Ugyldig telefonnummer",
  "errors.max-value-reached": "Maksimal verdi er nådd",
  "errors.min-value-reached": "Minste verdi er nådd",
  "errors.must-be-number": "Må være et tall",
  "errors.passwords-do-not-match": "Passordene er ikke like",
  "errors.passwords-not-equal": "Passordene er ikke like",
  "errors.reload-page": "Last siden på nytt",
  "errors.users.could-not-change-password": "Kunne ikke bytte passord",
  "errors.worksheets.readingtexts-need-full-layout":
    "Lesetekster må bruke fullside-layout",
  "existing-school-waiting-acceptance.description":
    "Før du kan bruke Arbeidsark må skolen din akseptere din forespørsel. Ta kontakt med din lokale Arbeidsark-administrator for å få hjelp.",
  "existing-school-waiting-acceptance.title":
    "Venter på bekreftelse fra skolen",
  "existing-school-waiting-acceptance.toast":
    "Brukeren din har blitt opprettet",
  "feide-missing-email.submit": "Oppdater e-post",
  "feide-missing-email.subtitle":
    "Vi fikk ikke med e-posten din fra Feide. Vennligst skriv den inn her. Du får deretter en e-post av oss hvor du må bekrefte e-post-adressen.",
  "feide-missing-email.title": "Vi mangler e-posten din",
  "files.drop-to-upload": "Dropp filer her for å laste dem opp",
  "files.file-too-large":
    "Filen {name} er større enn maksimal størrelse på {max}MB.",
  "files.upload-files-here": "Last opp filer her",
  "forgotten-password.forgotten": "Glemt passordet?",
  "forgotten-password.go-back": "Tilbake til innlogging",
  "forgotten-password.success":
    "Hvis kontoen din finnes, er en e-post på vei med instruksjoner for tilbakestilling av passord.",
  "forgotten-password.success-message": "En email har blit sendt til {user}",
  "forgotten-password.title": "Tilbakestill passord",
  "forgotten-password.title-success": "Passordet har blitt tilbakestilt",
  "handbook.add_sub_folder": "Add sub folder",
  "handbook.create-entry-success": "Innlegg opprettet",
  "handbook.create-folder-success": "Opprettet mappe",
  "handbook.create_entry": "Lag nytt innlegg",
  "handbook.edit_folder": "Edit folder",
  "handbook.entry-load-error": "Feil ved innlasting av innlegg",
  "handbook.entry.delete-success": "Slettet innlegg",
  "handbook.folder-load-error": "Feil ved innlasting av mappe",
  "handbook.folder.delete-success": "Slettet mappe",
  "handbook.search": "Søk i håndboken",
  "handbook.start": "Start",
  "handbook.update-entry-success": "Innlegget ble oppdatert",
  "handbook.update-folder-success": "Mappen ble oppdatert",
  "institution.add-more-users": "Legg til flere brukere",
  "institution.back-to-users": "Tilbake til brukere",
  "institution.invitation-sent": "Invitasjon har blitt sendt",
  "institution.invitations-sent": "Invitasjonene har blitt sendt",
  "institution.invite-users": "Inviter brukere",
  "institution.send-invitation": "Send invitasjon",
  "institution.update-success":
    "Oppdatering av institusjonsinformasjon var vellykket!",
  "institutions.sent-invitations": "Sendte invitasjoner: ",
  "login.already-registered": "Allerede registrert",
  "login.create-user": "Opprett bruker",
  "login.create-user-error": "Kunne ikke opprette bruker",
  "login.email-address-already-in-use": "E-post er opptatt",
  "login.forgotten-password": "Glemt passord",
  "login.not-already-registered": "Har du ikke opprettet bruker?",
  "login.organization-number-already-in-use":
    "Organisasjonsnummer er allerede registrert",
  "login.password": "Passord",
  "login.repeat-password": "Gjenta passord",
  "modal.and-all-its-content": " og alt den inneholder",
  "modal.delete-attachment": 'Ønsker du å slette "{title}" fra tilleggene?',
  "modal.delete-attachment-title": "Slette tillegg",
  "modal.delete-folder": "Slette mappe",
  "modal.delete-folder-description":
    'Ønsker du å slette mappen "{title}" og alt innholdet?',
  "modal.delete-folder-entry-description":
    'Ønsker du å slette innlegget "{title}"?',
  "modal.delete-folder-entry-title": "Slette innlegg",
  "modal.delete-folder-title": "Slette mappen",
  "modal.delete-type": "Er du sikker på at du ønsker å slette {type}",
  "modal.delete-type-description":
    "Er du sikker på at du ønsker å slette {type}?",
  "modal.delete-type-title": "Slette {type}",
  "modal.remove-attachment": 'Ønsker du å fjerne "{title}" fra tilleggslisten?',
  "modal.remove-attachment-title": "Fjerne tillegg",
  "new-school-awaiting-confirmation.description":
    "Før du kan bruke Arbeidsark må den nye skolen du har registrert bli godkjent av en administrator. Du vil få en e-post når skolen din er godkjent.",
  "new-school-awaiting-confirmation.title":
    "Venter på bekreftelse fra Arbeidsark",
  "new-school-awaiting-confirmation.toast": "Skolen din er opprettet",
  "new-subscription-required.description":
    "Du må kjøpe et nytt abonnement for å få tilgang til Arbeidsark",
  "new-subscription-required.title": "Kjøp nytt abonnement",
  "notifications.go-to-document": "Gå til dokument",
  "notifications.go-to-thread": "Gå til tråd",
  "operations.addition": "Addisjon",
  "operations.division": "Divisjon",
  "operations.multiplication": "Multiplikasjon",
  "operations.subtraction": "Subtraksjon",
  "pay-for-subscription.purchase": "Kjøp abonnement",
  "pay-for-subscription.title": "Registrer betalingsmetode",
  "payment-success.description":
    "Abonnementet ditt vil begynne å løpe umiddelbart.",
  "payment-success.title": "Suksess!",
  "payment-success.toast": "Betalingen ble gjennomført",
  "permissions.add": "Opprette",
  "permissions.change": "Endre",
  "permissions.change_sticky": "Endre festet tråd",
  "permissions.forum-send-email": "Sende e-post",
  "permissions.forum-send-sms": "Sende SMS",
  "permissions.no-access-to-page":
    "Brukeren din har ikke tilgang til denne siden",
  "permissions.organization-settings-general": "Generelt",
  "permissions.remove": "Slette",
  "permissions.view": "Se",
  "permissions.view-and-change": "Se/Endre",
  "register-organization.billing-email": "E-post til fakturering",
  "register-organization.title": "Faktureringsdetaljer",
  "register-school.choose-method.existing-school":
    "Bli med i eksisterende skole",
  "register-school.choose-method.new-school": "Opprett skole",
  "register-school.choose-method.title":
    "Opprett ny eller bli med i en eksisterende skole.",
  "register-school.chosen-school": "Valg skole",
  "register-school.create-user-and-join-school":
    "Opprett bruker og send forespørsel",
  "register-school.create-user-and-school": "Opprett bruker og skole",
  "register-school.search-for-school": "Søk etter skole",
  "register-school.title": "Skole — Registrer personalia",
  "register-user.description":
    "Siden dette er første gang du logger inn må du fylle ut noe standard informasjon.",
  "register-user.title": "Fyll inn personalia",
  "register.already-registered": "Har du allerede en bruker?",
  "register.bad-token-title": "Ugyldig url token",
  "register.complete-registration": "Fullfør registrering",
  "register.errors.bad-token": "Nøkkelen er ugyldig",
  "register.errors.expired-token": "Nøkkelen har utløpt",
  "register.expired-token-title": "Utgått url token",
  "register.registration-complete": "Registrering fullført",
  "register.to-login": "Tilbake til login",
  "register.verified-message":
    "Brukeren har blitt registrert og verifisert. Du kan nå logge inn i Arbeidsark.",
  "register.verified-title": "Brukeren er registrert",
  "register.verify-email-message":
    "En epost blir sendt med informasjon om hvordan du fullfører registreringen. Vennligst sjekk innboksen din.",
  "register.verify-email-title": "Verifiser brukerregistreringen",
  "reset-password.errors.bad-token": "Nøkkelen er ugyldig",
  "reset-password.errors.expired-token":
    "Tilbakestillingsnøkkelen har gått ut på dato.",
  "reset-password.go-back": "Tilbake til innlogging",
  "reset-password.message":
    "Vennligst skriv inn et nytt passord. Passordet må inneholde minst 8 tegn, og kan ikke kun bestå av bokstaver",
  "reset-password.submit": "Endre passord og logg inn",
  "reset-password.success": "Passordet har blitt endret",
  "reset-password.title": "Tilbakestill passordet ditt",
  "school-grades.fifth": "5. klasse",
  "school-grades.first": "1. klasse",
  "school-grades.fourth": "4. klasse",
  "school-grades.second": "2. klasse",
  "school-grades.seventh": "7. klasse",
  "school-grades.sixth": "6. klasse",
  "school-grades.third": "3. klasse",
  "select-multiple.deselect-all": "Fjern alle",
  "select-multiple.multiple-selected": "Flere valgt",
  "select-multiple.select-all": "Velg alle",
  "select-sex.label.female": "Dame",
  "select-sex.label.male": "Mann",
  "select-sex.label.rather-not-say": "Ønsker ikke oppgi",
  "select-subscription.title": "Hvor ofte vil du betale?",
  "select-user-setting.description":
    "Denne skjermen lar deg velge hvilke brukertyper som skal dukke opp i nedtrekksmenyen på visse sider. Alle brukere med minst en av brukertypene som er valgt vil komme opp i de nedtrekksmenyene.",
  "select-user-settings.title": "Bruker dropdown innstillinger",
  "selectOrganization.select": "Velg firma",
  "settings.add-absence-type": "Legg til fraværstype",
  "settings.add-issue-category": "Legg til avvikskategori",
  "settings.add-new-terminal": "Legg til ny terminal",
  "settings.added-issue-category": "La til ny avvikskategori",
  "settings.admin-paper-option": "Sendes til registrert adresse",
  "settings.billing.billing-email": "E-postadresse for faktura",
  "settings.billing.title": "Fakturering",
  "settings.change-logo": "Last opp ny logo",
  "settings.class": "Klassetrinn",
  "settings.current-password": "Nåværende passord",
  "settings.edit-type-settings": "Endre {type}innstillinger",
  "settings.errors.change-language": "Klarte ikke endre til ønsket språk",
  "settings.information": "Opplysninger",
  "settings.labels.billing-method": "Faktureringsmetode",
  "settings.my-settings": "Mine Innstillinger",
  "settings.new-password": "Nytt passord",
  "settings.organization-logo": "Bedriftslogo",
  "settings.organization-settings": "Bedriftsinnstillinger",
  "settings.personal-information": "Personlige opplysninger",
  "settings.repeat-new-password": "Gjenta nytt passord",
  "settings.save-changes": "Lagre endringer",
  "settings.save-settings": "Lagre innstillinger",
  "settings.saved-successfully": "Innstillinger lagret",
  "settings.tabs.billing": "Fakturering",
  "settings.tabs.change-password": "Bytt passord",
  "settings.tabs.information": "Opplysninger",
  "settings.toasts.change-language-success": "Endret foretrukket språk",
  "settings.toasts.password-changed-successfully": "Passordet ble lagret",
  "settings.tv-view": "Vis på TV",
  "settings.updated-type": "Oppdaterte {type}",
  "settings.updated-userinfo": "Oppdatert brukerinfo!",
  "settings.upload": "Last opp",
  "settings.upload-type": "Last opp {type}",
  "settings.which-class-are-you-teaching": "Hvilket trinn underviser du for?",
  "settings.work-place": "Arbeidsplass",
  "setup-success.description":
    "Abonnementet ditt vil begynne å løpe etter prøveperiodens utløp.",
  "setup-success.success": "Kortinformasjonen ble lagt til",
  "setup-success.title": "Suksess!",
  "share-link-modal.ingress":
    "Kopier lenken under og del den med venner eller kolleger. Lenken vil gi tilgang til dette spesifikke arbeidsarket.",
  "share-link-modal.title": "Deling av arbeidsark",
  "single-user-email-confirmation.button-with-count":
    "Send ny e-post ({count}s igjen)",
  "single-user-email-confirmation.button-without-count": "Send ny e-post",
  "single-user-email-confirmation.description":
    "Vennligst sjekk din innboks for en e-post fra oss. Du må bekrefte e-posten din før du kan bruke Arbeidsark.",
  "single-user-email-confirmation.new-email-sent": "Ny e-post sendt",
  "single-user-email-confirmation.title": "Venter på bekreftelse av e-post",
  "single-user-email-confirmation.toast": "Brukeren din har blitt opprettet",
  "subscription-cancelled.buy-new": "Kjøp nytt abonnement",
  "subscription-cancelled.title": "Abonnement kansellert",
  "subscription-cancelled.you-have-access-to": "Du har tilgang frem til {date}",
  "subscription-personal.cancel": "Avslutt abonnement",
  "subscription-personal.has-payment-method-text":
    "Du har lagt til betalingsmetode og vil bli trukket {sum} kr ved prøveperiodens slutt.",
  "subscription-personal.price": "{price} kr/mnd",
  "subscription-personal.reactivate":
    "Har du ombestemt deg? Aktiver abonnementet på nytt.",
  "subscription-personal.reactivate-confirm":
    "Er du sikker på at du vil aktivere abonnementet ditt på nytt?",
  "subscription-personal.regular-button": "Bytt betalingsmetode",
  "subscription-personal.regular-subtitle": "Trekkes automatisk {date}",
  "subscription-personal.regular-title": "Standardbruker",
  "subscription-personal.trial-button": "Fullfør kjøp",
  "subscription-personal.trial-info":
    "Du vil få informasjon om betaling og abonnement når utløpet av prøveperioden nærmer seg.",
  "subscription-personal.trial-subtitle": "Prøvetiden utgår {date}",
  "subscription-personal.trial-title": "Gratis prøvetid",
  "subscription-personal.will-cancel":
    "Du har kansellert abonnementet og vil ikke bli trukket ved periodens utløp.",
  "subscription-personal.will-cancel-subtitle":
    "Du har tilgang frem til {date}",
  "subscription-school-cancelled.reactivate-subscription":
    "Reaktiver abonnement",
  "subscription-school-cancelled.subtitle":
    "Du har kansellert abonnementet til skolen din. Tilgangen til Arbeidsark for alle lærerne dine går ut {date}.",
  "subscription-school-cancelled.toast.success":
    "Abonnement reaktivert! Velkommen tilbake.",
  "subscription-school-member.description":
    "Du har en bruker som er en del av et skoleabonnement. Ta kontakt med en administratorbruker på din skole hvis du lurer på noe:",
  "subscription-school.active.edit-billing-info":
    "Rediger faktureringsdetaljer",
  "subscription-school.active.will-be-billed-at": "Faktureres {date}",
  "subscription-school.cancel.confirm-cancel":
    "Jeg er sikker på at jeg vil kansellere",
  "subscription-school.cancel.keep-subscription": "Behold abonnement",
  "subscription-school.cancel.last-access-info":
    "Siste dag med tilgang vil være {date}",
  "subscription-school.cancel.title":
    "Er du sikker på at du vil avslutte abonnementet?",
  "subscription-school.cancel.toast-text":
    "Alle brukere assosiert med skolen din vil miste tilgang  etter abonnementets utløp.",
  "subscription-school.no-subscription.buttonText": "Start nytt abonnement",
  "subscription-school.no-subscription.disclaimer":
    "* Ved å trykke godtar du på vegne av {school} å bli belastet et årlig abonnement av Arbeidsark AS.",
  "subscription-school.no-subscription.title":
    "Skolen din har ikke noe abonnement 😔",
  "subscription-school.no-subscription.toast.success": "Velkommen tilbake!",
  "subscription-school.trial.activate": "Aktiver abonnement",
  "subscription-school.trial.active-description":
    "Du har valgt å aktivere abonnementet etter prøvetiden. Første faktura vil bli sendt {date}.",
  "subscription-school.trial.deactivate": "Deaktiver abonnement",
  "subscription-school.trial.subtitle": "Prøvetiden utgår {date}",
  "subscription-school.trial.title": "Gratis prøvetid - Skole",
  "subscription-will-cancel.modal.title": "Hurra!",
  "subscriptions.cancel-subscription": "Avslutt abonnement",
  "subscriptions.change-periodicity": "Endre faktureringsintervall",
  "subscriptions.current-subscription": "Nåværende",
  "subscriptions.try-for-free-30-days": "Prøv Arbeidsark gratis",
  "table.week-sum": "Ukesum",
  "terminal.check-in": "Sjekk inn",
  "terminal.check-out": "Sjekk ut",
  "terminal.checked-in": "Sjekket inn",
  "terminal.checked-in-at": "Sjekket inn kl. {time}",
  "terminal.checked-in-message":
    "Du sjekket inn {checkIn} og har arbeidet {total} timer",
  "terminal.checked-out": "Sjekket ut",
  "terminal.checked-out-at": "Sjekket ut kl. {time}",
  "terminal.ip-address": "IP adresse",
  "terminal.ip-filter-range": "IP filterområde",
  "terminal.no-activity-period":
    "Du har ikke noe registrert aktivitet for valgt periode",
  "terminal.no-activity-today": "Du har ikke registrert noen aktivitet i dag.",
  "terminal.not-on-network":
    "Du må være på et terminalnettverk for å sjekke ut eller inn",
  "terminal.terminal-areas": "Terminalområder",
  "terminal.terminal-name": "Terminalnavn",
  "terminal.time": "Tid",
  "terminal.user-activity": "Aktiviteten til {user}",
  "terminal.user-no-activity-period":
    "{user} har ikke noe registrert aktivetet for valgt periode",
  "terminal.your-activity": "Din aktivitet",
  "terminal.your-activity-today": "Din aktivitet i dag",
  "thread.success-creation": "Opprettet ny tråd",
  "timesheets.absence-create-type": "Opprett ny fraværstype",
  "timesheets.absence-type": "Fraværstype",
  "timesheets.absence-type-name": "Fraværstypenavn",
  "timesheets.absence-types": "Fraværstyper",
  "timesheets.absence-types-error-1":
    "Fravær kan ikke bli lagt til mer enn én gang per dag per ansatt.",
  "timesheets.error-registration-absence":
    "Feil ved registrering av nytt fravær",
  "timesheets.error-registration-timeentry":
    "Feil ved registrering av nye timer",
  "timesheets.error-update-absence": "Feil ved oppdatering av fravær",
  "timesheets.error-update-timeentry": "Feil ved oppdatering av timer",
  "timesheets.note": "Notat",
  "timesheets.register-absence": "Registrer fravær",
  "timesheets.register-timeentry": "Registrer nye timer",
  "timesheets.success-registration-absence": "Nytt fravær registrert",
  "timesheets.success-registration-timeentry": "Nye timer registrert",
  "timesheets.success-update-absence": "Fravær oppdatert",
  "timesheets.success-update-timeentry": "Timer oppdatert",
  "timesheets.update-absence": "Oppdater fravær",
  "timesheets.update-timeentry": "Oppdater timer",
  "timesheets.view-all-absence": "Alt fravær",
  "timesheets.view-all-timeentries": "Alles timer",
  "timesheets.view-your-absence": "Ditt fravær",
  "timesheets.view-your-timeentries": "Dine timer",
  "toasts.error": "Feil",
  "toasts.error-add-type": "Kunne ikke legge til {type}",
  "toasts.error-delete-type": "Kunne ikke slette {type}",
  "toasts.error-update-type": "Kunne ikke oppdatere {type}",
  "toasts.error.upload-type": "Kunne ikke laste opp {type}",
  "toasts.info": "Info",
  "toasts.success": "Suksess",
  "toasts.success-add-type": "La til ny {type}",
  "toasts.success-delete-type": "Slettet {type}",
  "toasts.success-update-type": "Oppdaterte {type}",
  "toasts.success.upload-type": "Lastet opp {type}",
  "toasts.warning": "Advarsel",
  "user-type-settings.delete-prompt-text":
    "Er du sikker på at du vil slette brukertypen?",
  "user-type-settings.delete-prompt-title": "Slett brukertype",
  "user-type-settings.description":
    "På denne siden kan du endre brukertyper og tilganger.",
  "user-type-settings.description-2":
    'Merk at alle endringer under "Endre" og "Slette" gir deg tilgang til å endre og slette ressurser opprettet av andre. Alle som har tilgang til å lage en ressurs har også tilgang til å endre sine egne ressurser.',
  "user-type-settings.title": "Brukertyper og tilganger",
  "user-type-settings.toasts.error": "Feil ved oppdatering",
  "user-type-settings.toasts.success": "Oppdaterte brukertyper",
  "user-types.change-settings-label": "Endre",
  "user-types.create-settings-label": "Opprette",
  "user-types.driver-activities-self": "Kjøredata (egen)",
  "user-types.everyones-driver-activities": "Kjøredata (alles)",
  "user-types.remove-settings-label": "Slette",
  "user-types.view-settings-label": "Se",
  "users.accept-user-join-request": "Aksepter og aktiver",
  "users.activated-user": "{email} sin konto har blitt aktivert.",
  "users.active": "Aktiv",
  "users.add-user": "Legg til bruker",
  "users.admin-password-reset-success":
    "Passordet ble tilbakestilt, og e-post er sendt til brukeren.",
  "users.bio": "Profilbiografi",
  "users.birth-number": "Fødselsnummer",
  "users.change-picture": "Endre bilde",
  "users.change-profile-picture": "Endre bilde",
  "users.class": "klasse",
  "users.contact-person-name": "Kontaktperson navn",
  "users.contact-person-phone": "Kontaktperson telefon",
  "users.deactivated-user": "{email} sin konto har blitt deaktivert.",
  "users.driver-card-number": "Sjåførkort",
  "users.edit-profile": "Redigér profil",
  "users.edit-profile-information": "Redigér profilinformasjonen",
  "users.edit-user": "Redigér bruker",
  "users.grade": "Klassetrinn",
  "users.has-no-organizations":
    "Du er ikke assosiert med noen firmaer. Vennligst ta kontakt med administatoren din.",
  "users.inactive": "Inaktiv",
  "users.internal-number": "Internnummer",
  "users.my-profile": "Min Profil",
  "users.new": "Ny bruker",
  "users.personal-info": "Personlig informasjon",
  "users.profile": "Profil",
  "users.reject-user-join-request": "Avvis forespørsel",
  "users.remove-user-from-organization": "Fjern fra organisasjon",
  "users.reset-password": "Tilbakestill passord",
  "users.reset-password-email-sent-by-admin":
    "Tilbakestill passord email sent til {email}",
  "users.search": "Søk etter bruker",
  "users.settings": "Mine innstillinger",
  "users.user-activated": "Bruker aktivert",
  "users.user-deactivated": "Bruker deaktivert",
  "users.user-removed-success": "Brukeren ble fjernet.",
  "validation.no-white-space-end": "Mellomrom på slutten av navnet",
  "warnings.worksheets.arithmetic-operation-might-not-be-supported-for-grade":
    "Uvanlig kombinasjon av klassetrinn og operasjon",
  "warnings.worksheets.task-type-not-supported-for-grade":
    "{taskType} er ikke støttet for det valgte klassetrinnet. ",
  "worksheets.arithmetic-detail-modal.set-lowest-highest":
    "Sett laveste og høyeste tall",
  "worksheets.buttons.generate-worksheet": "Generer arbeidsark",
  "worksheets.buttons.regenerate": "Generer på nytt",
  "worksheets.buttons.hide-options": "Skjul tilpasninger",
  "worksheets.buttons.show-options": "Tilpass",
  "worksheets.delete-success": "Arbeidsark slettet",
  "worksheets.grade-groups.fiveToSeven": "5-7. trinn",
  "worksheets.grade-groups.oneToFour": "1-4. trinn",
  "worksheets.labels.arithmetic-operation": "Velg regneart",
  "worksheets.labels.configure": "Tilpass",
  "worksheets.labels.grade": "Velg klassetrinn",
  "worksheets.labels.language-theme": "Velg tema",
  "worksheets.labels.math-module": "Velg oppgavetyper",
  "worksheets.labels.name": "Navn",
  "worksheets.labels.number-of-pages": "Antall sider",
  "worksheets.labels.page": "Side",
  "worksheets.labels.page-layout": "Oppgavelayout",
  "worksheets.labels.random": "Tilfeldig",
  "worksheets.labels.random-plural": "Tilfeldige",
  "worksheets.labels.select-task-types": "Velg oppgavetyper",
  "worksheets.labels.select-theme": "Velg grafikk",
  "worksheets.labels.task": "Oppgave",
  "worksheets.labels.theme": "Velg grafikk",
  "worksheets.language-theme.birds": "Fugler",
  "worksheets.language-theme.bugs": "Insekter",
  "worksheets.language-theme.christmas": "Jul",
  "worksheets.language-theme.clothes": "Klær",
  "worksheets.language-theme.colours": "Farger",
  "worksheets.language-theme.farm-animals": "Gårdsdyr",
  "worksheets.language-theme.forest-animals": "Skogsdyr",
  "worksheets.language-theme.fruits-and-berries": "Frukt og bær",
  "worksheets.language-theme.months": "Måneder",
  "worksheets.language-theme.my-family": "Min familie",
  "worksheets.language-theme.my-house": "Mitt hus",
  "worksheets.language-theme.space": "Verdensrommet",
  "worksheets.language-theme.the-body-external": "Kroppen (utsiden)",
  "worksheets.language-theme.the-body-internal": "Kroppen (innsiden)",
  "worksheets.language-theme.vegetables": "Grønnsaker",
  "worksheets.language-theme.water-seashore": "I fjæra",
  "worksheets.language-theme.weather-and-seasons": "Vær og årstider",
  "worksheets.language-theme.weekdays": "Ukedager",
  "worksheets.options.arithmetic-operation":
    "{operation, select, addition {Addisjon} subtraction {Subtraksjon} multiplication {Multiplikasjon} division {Divisjon} other {Andre}}",
  "worksheets.options.math-module":
    "{module, select, arithmeticAlgorithms {Algoritmer aritmetikk} arithmeticSimple {Aritmetikk - Enkel} arithmeticFractionsSimple {Aritmetikk Brøk - Enkel} clockAnalogoue {Klokke - Analog} clockDigital {Klokke - Digital} guessTheHouse {Gjett huset} numberGrid {Tallruter} numberLines {Tallinje} numberPyramids {Tallpyramide} numberSequence {Tallsekvens} numberSort {Tallsortering} patterns {Tallmønstre} standardAlgorithm {Standard Algoritme} sudoku {Sudoku} random {Tilfeldige} other {Random}}",
  "worksheets.options.page-layout":
    "{pageLayout, select, ONE {En per side} ONEONE {En oppe, en nede} ONETWO {En oppe, to nede} TWOONE {To oppe, en nede} TWOTWO {To oppe, to nede} ONEONEONEONE {Fire rader med en hver} other {Andre}}",
  "worksheets.options.theme":
    "{theme, select,  christmas {Jul} easter {Påske} halloween {Halloween} mermaids {Havfruer} numberchars {Tall & Bokstaver} space {Verdensrommet} tools {Verktøy} unicorn {Enhjørninger} other {Annet}}",
  "worksheets.page-layouts.full": "Én oppgave per side",
  "worksheets.page-layouts.half": "To oppgaver per side",
  "worksheets.search-placeholder": "Søk etter arbeidsark...",
  "worksheets.task-types.generic.crossword": "Kryssord",
  "worksheets.task-types.generic.readingTexts": "Lesetekster",
  "worksheets.task-types.generic.wordSearch": "Ordleting",
  "worksheets.task-types.mathematics.arithemtic": "Aritmetikk",
  "worksheets.task-types.mathematics.arithmetic": "Aritmetikk",
  "worksheets.task-types.mathematics.grid": "Tallruter",
  "worksheets.task-types.mathematics.guessTheHouse": "Gjett huset",
  "worksheets.task-types.mathematics.mathCrossBox": "Kryssmatte",
  "worksheets.task-types.mathematics.neighbourNumbers": "Nabotall",
  "worksheets.task-types.mathematics.numberPatterns": "Tallmønster",
  "worksheets.task-types.mathematics.numberSeries": "Tallrekker",
  "worksheets.task-types.mathematics.pyramid": "Tallpyramide",
  "worksheets.task-types.mathematics.sorting": "Sortering",
  "worksheets.task-types.mathematics.standardAlgorithm": "Standardalgoritme",
  "worksheets.task-types.mathematics.sudoku": "Sudoku",
  "worksheets.themes.17mai": "17. mai",
  "worksheets.themes.christmas": "Jul",
  "worksheets.themes.halloween": "Halloween",
  "worksheets.themes.mermaids": "Havfruer",
  "worksheets.themes.numberchars": "Tall og bokstaver",
  "worksheets.themes.space": "Verdensrommet",
  "worksheets.themes.tools": "Ark og blyant",
  "worksheets.themes.unicorn": "Enhjørning",
  "worksheets.title-placeholder": "Arbeidsark nr. {total} - {date}",
  "worksheets.wordlist-modal.edit-words": "Rediger ord",
  "worksheets.worksheet-generator": "Arbeidsarkgenerator",

  // Onboarding Tour
  "onboarding.tour.welcome.title": "Velkommen til den nye generatoren!",
  "onboarding.tour.welcome.description":
    "Den nye arbeidsarkgeneratoren gir deg umiddelbar forhåndsvisning av arbeidsarkene mens du lager dem. La oss ta en rask omvisning!",
  "onboarding.tour.preview.title": "Umiddelbar forhåndsvisning",
  "onboarding.tour.preview.description":
    "Se arbeidsarket oppdateres i sanntid mens du gjør endringer. Ikke mer venting på at PDF-en skal genereres!",
  "onboarding.tour.tabs.title": "Bytt fag",
  "onboarding.tour.tabs.description":
    "Velg mellom matematikk, norsk og engelsk ved å bruke disse fanene.",
  "onboarding.tour.settings.title": "Tilpass arbeidsarket ditt",
  "onboarding.tour.settings.description":
    "Sett navn, klassetrinn, operasjoner, layout, oppgavetyper og tema for arbeidsarket ditt her.",
  "onboarding.tour.pages.title": "Legg til sider",
  "onboarding.tour.pages.description":
    "Bruk + og - knappene for å legge til eller fjerne sider fra arbeidsarket ditt.",
  "onboarding.tour.page-config.title": "Side-for-side redigering",
  "onboarding.tour.page-config.description":
    "Hver side kan tilpasses individuelt. Klikk for å utvide og se alternativer for hver oppgave.",
  "onboarding.tour.configure.title": "Tilpass oppgaver",
  "onboarding.tour.configure.description":
    "Du kan tilpasse hver individuelle oppgave ved å trykke på denne knappen.",
  "onboarding.tour.module-regenerate.title": "Regenerer oppgave",
  "onboarding.tour.module-regenerate.description":
    "Når du har endret konfigurasjon på en oppgave trykker du på denne knappen for å generere den på nytt. Ingen andre oppgaver i arket ditt blir endret av dette.",
  "onboarding.tour.global-regenerate.title": "Regenerer hele arket",
  "onboarding.tour.global-regenerate.description":
    "Trykk her for å regenerere alle oppgaver på hele arbeidsarket med de valgte innstillingene.",
  "onboarding.tour.download.title": "Last ned PDF",
  "onboarding.tour.download.description":
    "Last ned arbeidsarket som en PDF-fil for å skrive ut eller dele.",
  "onboarding.tour.save.title": "Lagre i biblioteket",
  "onboarding.tour.save.description":
    "Lagre arbeidsarket i biblioteket ditt for enkel tilgang senere. Det blir også lastet ned automatisk.",
  "onboarding.tour.done.title": "Du er klar!",
  "onboarding.tour.done.description":
    "Nå kan du det grunnleggende i den nye generatoren. Begynn å lage arbeidsarket ditt! Du kan ta omvisningen på nytt når som helst ved å klikke på hjelpeknappen.",
  "onboarding.tour.buttons.next": "Neste",
  "onboarding.tour.buttons.prev": "Forrige",
  "onboarding.tour.buttons.done": "Kom i gang",
  "onboarding.tour.buttons.skip": "Hopp over",
  "onboarding.tour.help-button.tooltip": "Ta omvisningen",
}
export default nb
